export class Utils {

    /**
     * Convert base64 into new file with extension.png
     * 
     * @param dataURI base64 data
     * @param fileName  name of the file
     */
    public static dataURItoBlob(dataURI: any, fileName: string): File {
        let byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0)
            byteString = atob(dataURI.split(',')[1]);
        else
            byteString = unescape(dataURI.split(',')[1]);

        // separate out the mime component
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to a typed array
        const ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        return new File([ia], fileName + '.png', { type: 'image/png' });
    }

    /**
     * Rename a file creating a new one
     * @param originalFile 
     * @param newName 
     * @returns File 
     */

    public static renameFile(originalFile, newName, extension) {
        return new File([originalFile], newName.length >= 49 ? newName.substring(0, 45) + extension : newName + extension, {
            type: originalFile.type,
            lastModified: originalFile.lastModified,
        });
    }

    /**
     * Transform string value with ',' decimal to number
     * @param stringNumber
     * @returns number 
     */
    public static StringToNumber(stringNumber) {
        try {
            let value = stringNumber.toString().replace(',', '.');
            value = +value.replace(/[A-Z]/i, '');
            return this.trunc(value) || 0
            //return value||0;
        }
        catch {
            return 0
        }
    }

    /**
     * Transform string value with '.' decimal to string with ',' decimal
     * @param value
     * @returns formatedValue 
     */
    public static getFormatedValue(value) {
        let formatedValue = Number.parseFloat(value).toFixed(2);
        formatedValue = formatedValue.toString().replace('.', ',')
        return formatedValue
    }


    /**
     * Truncate a number with n figures
     * @param x value to truncate
     * @param n number of figures to truncate
     * @returns truncated value 
     */
    public static trunc(x) {
        let ret = x;
        let str = x.toString();
        var decimalLength = str.indexOf('.')
        if (decimalLength > -1) {
            ret = Number(str.substring(0, decimalLength + 3))
        }
        return ret
    }


}